// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.acc-tr-border-bottom {\n border-bottom: 1px solid #e1e3eb\n}\n", ""]);
// Exports
module.exports = exports;
